/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import getters from './getters';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    user: user
  },
  getters: getters
});
export default store;